import { Controller } from "@hotwired/stimulus";
import { dialogCancelButtonClassName, dialogConfirmationButtonClassName } from "../../../../../../scripts/dialogConstants";
import { postRequestAndWaitForJobCompletion } from "../../../../../../scripts/jobCompletion";
import { translate } from "../../../../../../scripts/translate";
import * as TranslationsKeys from "../../../../../../scripts/locale/translationsKeys";
import { DomEvents } from "../../../../../../scripts/_generated/DomEvents";

export default class AiGeneratedContentController extends Controller {
    static targets = [
        "generateButton",
        "clearButton",
    ];

    static values = {
        getJobUrl: String,
        generateUrl: String,
        clearUrl: String,
        poiUniqueId: String,
    };

    readonly generateButtonTarget!: HTMLElement;
    readonly clearButtonTarget!: HTMLElement;

    readonly getJobUrlValue!: string;
    readonly generateUrlValue!: string;
    readonly clearUrlValue!: string;
    readonly poiUniqueIdValue!: string;

    connect() {
    }

    generate() {
        const action = () => {
            const data = new FormData();
            data.append("commaSeparatedPoiUniqueIds", this.poiUniqueIdValue);
            postRequestAndWaitForJobCompletion(this.generateUrlValue,
                data,
                this.getJobUrlValue,
                $(this.generateButtonTarget),
                () => {
                    this.dispatch(DomEvents.poiDetailAiGeneratedContentModified);
                });
        };

        bootbox.confirm({
            message: 'Really re-generate AI description?',
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Ok),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback(result) {
                if (!result) return;

                action();
            }
        });
    }

    clear() {
        const action = () => {
            const data = new FormData();
            data.append("commaSeparatedPoiUniqueIds", this.poiUniqueIdValue);
            postRequestAndWaitForJobCompletion(this.clearUrlValue,
                data,
                this.getJobUrlValue,
                $(this.clearButtonTarget),
                () => {
                    this.dispatch(DomEvents.poiDetailAiGeneratedContentModified);
                });
        };

        bootbox.confirm({
            message: 'Really remove AI description?',
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Ok),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback(result) {
                if (!result) return;

                action();
            }
        });
    }
}